export const KPI_BETA_SITES = [
  { key: "su", title: "Syracuse University", sidebarKey: "kpi_beta_su" },
  { key: "caesars", title: "Caesars NOBU", sidebarKey: "kpi_beta_caesars" },
  { key: "foa", title: "IPSec FOA", sidebarKey: "kpi_beta_foa" },
  { key: "mocn-foa", title: "MOCN FOA", sidebarKey: "kpi_beta_mocn_foa" },
  { key: "windsor", title: "Windsor", sidebarKey: "kpi_beta_windsor" },
];

export const KPI_BETA_SITE_BY_KEY = Object.fromEntries(
  KPI_BETA_SITES.map((site) => [site.key, site])
);